import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as TyreReturnOrderModels from '../../models/tyre-return-order/tyre-return-order';
import { TyreReturnOrderSearchModel } from '../../models/tyre-return-order/tyre-return-orderSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as Models from '../../models/commonModels';


@Injectable({
  providedIn: 'root'
})

export class TyreReturnOrderService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getList(Search: TyreReturnOrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreReturnOrderModels.TyreReturnOrderListModel>(`${this.environmentService.getApiURL()}/tyre-return-order/list`, Search, options);
  }

  public getStatusDictionary() {
    return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/tyre-return-order/status`);
  }

  public getFilteredReport(Search: TyreReturnOrderSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/tyre-return-order/report/filtered`, Search, options);
  }

  public set(TyreReturnOrder: Models.Request<TyreReturnOrderModels.TyreReturnOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreReturnOrderModels.TyreReturnOrderModel>>(`${this.environmentService.getApiURL()}/tyre-return-order/set`, TyreReturnOrder, options);
  }

  public get(TyreReturnOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreReturnOrderModels.TyreReturnOrderModel>>(`${this.environmentService.getApiURL()}/tyre-return-order/get`, TyreReturnOrder, options);
  }
}
